module.exports = __webpack_public_path__ + "img/video-play-icon.ccd47726.svg";